<div [@fadeimagesInOut]>
    <div class="brand-detail-section" [ngClass]="{'global-loader2':global_loader}">
        <div class="w-block wt-block bg-white">
            <div class="ab-container p-16">
                <div class="row">
                    <div class="breadcrum-container">
                        <nav class="d-flex justify-content-between" aria-label="breadcrumb">
                            <ol class="breadcrumb-list pl-0">
                                <li class="breadcrumb-item " aria-current="page" routerLink="">Home</li>
                                <li class="breadcrumb-item " aria-current="page" (click)="onBrand()">
                                    Brands</li>
                                <li class="breadcrumb-item active" aria-current="page"> {{brand_info?.name}}</li>
                            </ol>
                            <button title="Back" class="back-btn" style="width: fit-content;"
                                (click)="_location.back()"> <i class="fa fa-angle-left "></i>
                                Back</button>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div class="m-block top-strip-for-mob-back">
            <div (click)="onBrand()">
                <a aria-current="page"> <img
                        src="https://res.cloudinary.com/afterbricks/image/upload/v1682438470/icons/back_g6vjro.png"
                        alt="back to product"></a>
                <p>All Brands</p>
            </div>
            <div class="brand-img-mob">
                <img *ngIf="brand_info?.logo" src="{{brand_info?.logo}}" [alt]=brand_info?.name />
            </div>
        </div>
        <div class="ab-container pb-0 bg-white" >
            <div class=" banner-container" *ngIf="!global_loader">
                <img *ngIf="brand_info?.cover_pic" width="1600" height="400" [ngSrc]="brand_info?.cover_pic" alt="{{brand_info?.name}}" loading="eager">
            </div>
            <div class="banner-container-loader" *ngIf="global_loader">
            </div>
            <div class="ab-profile-detail row" *ngIf="!global_loader" data-id="ab-profile-detail">
                <div class="col-md-6 col-sm-12">
                    <h1>{{brand_info?.name}}</h1>
                    <p> {{ brand_info?.address}} {{brand_info?.city}}</p>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="con-info">
                        <a class="con-btn" (click)="onConnect()">
                            <i class="fa-regular fa-paper-plane"></i>
                            <span>Connect</span>
                        </a>
                        <a class="con-btn" title="{{brand_info?.name}} office website link" [href]="brand_info?.website" target="_blank">
                            <i class="fa-solid fa-link"></i>
                            <span>Website</span>
                        </a>
                        <div class="rounded-circle share-btn" (click)="onShare()">
                            <i class="fa-solid fa-share"></i>
                        </div>
                    </div>
                </div>
                <div class="profile-cover-pick-section">
                    <img *ngIf="brand_info?.logo" [src]="brand_info?.logo" [alt]="brand_info?.name">
                </div>

            </div>
            <div class="row product-dealer-company-header" *ngIf="!global_loader">
                <ul class="main-cat-list d-flex justify-content-start">
                    <li [ngClass]="{ 'active' : maintabs===1}" (click)="onCategoryTab(1, true)">
                        <div class="act-sec-tab" title="Products">Products</div>
                    </li>
                    <li [ngClass]="{ 'active' : maintabs===4}" (click)="onCategoryTab(4, true)">
                        <div class="act-sec-tab" title="About Company">Most viewed</div>
                    </li>
                    <!-- <li (click)="onDealerDetail()" [ngClass]="{ 'active' : maintabs===2}">
                        <div class="act-sec-tab" title="Dealers">Dealers</div>
                    </li> -->
                    <li [ngClass]="{ 'active' : maintabs===3}" (click)="onCategoryTab(3, true)">
                        <div class="act-sec-tab" title="About Company">About</div>
                    </li>
                </ul>
            </div>
        </div>
        <!-------------loader------------->
        <div class="ab-container-full is-loading" *ngIf="global_loader">
            <div class=" banner-container name">
            </div>
        </div>

        <div class="ab-container-full" *ngIf="productSection" #product>
            <div class="ab-container brand-details">
                <div class="chip-and-product-detail-cont" *ngIf="sub_category_list?.length || product_list?.length">
                    <!-- <div class="m-block" *ngIf="sub_category_list?.length">
                        <div class="pro-categories">
                            <p>Product Categories</p>
                        </div>
                    </div> -->
                    <div class="row" *ngIf="!global_loader">
                        <div class="col-12" *ngIf="sub_category_list?.length">
                            <ul class="chip-ul side-pad">
                                <li class="chip-li" *ngFor="let subcat of sub_category_list;let subcati=index"
                                    (click)="onSubcat(subcat.id)">
                                    <a class="chip-card" [title]="subcat?.name"
                                        [ngClass]="{'active-chip-manu':activesubcategory_id === subcat.id}">
                                        {{subcat?.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 pb-2 side-pad bg-mb" *ngIf="total_product">
                            <div class="numbers-of-product">
                                <p *ngIf="subCateName">{{subCateName}}:<span>{{total_product}}</span></p>
                                <p *ngIf="!subCateName">Products:<span>{{total_product}}</span></p>
                            </div>
                        </div>

                        <ul class="product-card-2 bg-mb side-pad pt-0" *ngIf="product_list?.length">
                            <li *ngFor="let product of product_list" >
                                <a class="product-detail-container" [title]="product.name" routerLink="../../p/{{product.slug_name}}">
                                    <div class="cashback-chip" *ngIf="product.cashback">
                                        <p> Cashback {{product?.cashback?.cashback}}%</p>
                                    </div>
                                    <div class="product-details-img">
                                        <img src={{product?.image_list[0]?.image_url}} alt="{{product?.slug_name}}">
                                    </div>
                                    <div class="product-detail">
                                        <div class="d-flex justify-content-between">
                                            <p>{{product.brand}}</p>
                                            <div *ngIf="product.view_count" class="view-count"><i aria-hidden="true"
                                                    class="fa fa-eye" style="margin-right: 4px;"></i>
                                                {{product.view_count}}</div>
                                        </div>
                                        <p class="name">{{product.name}}</p>
                                        <div class="product-detail-price" *ngIf="product.price">
                                            <p
                                                *ngIf="!product.discount && (product.calculation_type !=='sqft_wise' && product.calculation_type !=='sheet_wise' && product.calculation_type !=='meter_wise')">
                                                <span class="price-text">Price :</span> &#8377;{{product.price |
                                                number:'1.0-1'}}
                                            </p>
                                            <p
                                                *ngIf="product.discount && (product.calculation_type !=='sqft_wise' && product.calculation_type !=='sheet_wise' && product.calculation_type !=='meter_wise')">
                                                <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                                |
                                                number:'1.0-1'}}<br> <s style="color: #222;">MRP &#8377;{{product?.price
                                                    |
                                                    number:'1.0-1'}}</s> <span class="dis-off">{{product?.discount}}%
                                                    Off</span>
                                            </p>


                                            <p
                                                *ngIf="!product.discount && (product.calculation_type ==='sqft_wise' || product.calculation_type ==='sheet_wise')">
                                                <span class="price-text">Price :</span> &#8377;{{product.price |
                                                number:'1.0-1'}}/sqft
                                            </p>
                                            <p
                                                *ngIf="product.discount && (product.calculation_type ==='sqft_wise' || product.calculation_type ==='sheet_wise')">
                                                <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                                |
                                                number:'1.0-1'}}/sqft <br><s style="color: #222;">MRP
                                                    &#8377;{{product?.price | number:'1.0-1'}}/sqft</s> <span
                                                    class="dis-off">{{product?.discount}}% Off</span>
                                            </p>
                                            <p
                                            *ngIf="!product.discount && (product.calculation_type ==='meter_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.price |
                                            number:'1.0-1'}}/Meter
                                        </p>
                                        <p
                                            *ngIf="product.discount && (product.calculation_type ==='meter_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                            |
                                            number:'1.0-1'}}/Meter <br><s style="color: #222;">MRP
                                                &#8377;{{product?.price | number:'1.0-1'}}/Meter</s> <span
                                                class="dis-off">{{product?.discount}}% Off</span>
                                        </p>
                                            <span class="size-font d-flex" *ngIf="product?.size">Size
                                                ({{product?.size}})</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="col-12 product-page mt-3-mob" *ngIf="total_product>20 && !global_loader">
                            <div class="pagenetar-c py-4">
                                <p-paginator [rows]="20" [totalRecords]="total_product"
                                    (onPageChange)="onPageChange($event)">
                                </p-paginator>
                                <div class="w-block wt-block"
                                    style="position: absolute;top: 39px; color: #484848;font-size: 14px;left:10px;">
                                    <span>Page - {{dpage_number}} of {{total_num_of_product_pages}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!------------------------------Loader starts-------------------------------------------------->
                    <div class="row" *ngIf="global_loader">
                        <div class="col-12 pb-1 pt-2">
                            <ul class="chip-ul is-loading">
                                <li class="chip-li " *ngFor="let subcat of [1,2,3,4,5,6,7,8];let subcati=index">
                                    <a class="chip-card"></a>
                                </li>
                            </ul>
                        </div>
                        <ul class="product-card-2 is-loading loader-height">
                            <li *ngFor="let product of [1,2,3,4,5,6,7,8,9,10, 1,2,3,4,5,6,7,8,9,10]">
                                <div class="product-detail-container">
                                    <div class="product-details-img product-img-1">
                                    </div>
                                    <div class="product-detail" style="margin-top: 6px;">
                                        <p class="brand"></p>
                                        <p class="name"></p>
                                        <div class="product-detail-price name"></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!------------------------------Loader END-------------------------------------------------->
                    </div>
                </div>
                <div class="col-12 px-0 mt-24 Noproduct-section-mob" *ngIf="!sub_category_list.length && !global_loader"
                    style="border-radius: 16px;background: #fff;">
                    <div class="row NoProduct">
                        <div class="col-12 noproductscart pt-4">
                            <img class="ar" src="assets/images/noorderproduct.png" alt="arrow">
                            <p class="font-12m line-height-12">No products available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ab-container" *ngIf="mostViewProductList?.length && (maintabs===4)">
            <div class="row mt-24">
                <div class="col-12 popular-products-tab">

                    <ul class="product-card-2" *ngIf="product_list?.length">
                        <li *ngFor="let product of mostViewProductList;let i = index" routerLink="../../p/{{product.slug_name}}">
                            <a class="product-detail-container" [title]="product.name">
                                <div class="cashback-chip" *ngIf="product.cashback">
                                    <p> Cashback {{product?.cashback?.cashback}}%</p>
                                </div>
                                <div class="product-details-img">
                                    <img width="196" height="196" ngSrc={{product?.image_list[0]?.image_url}} alt="{{product?.slug_name}}" >
                                </div>
                                <div class="product-detail">
                                    <div class="d-flex justify-content-between">
                                        <p>{{product.brand}}</p>
                                        <div *ngIf="product.view_count" class="view-count"><i aria-hidden="true"
                                                class="fa fa-eye" style="margin-right: 4px;"></i>
                                            {{product.view_count}}</div>
                                    </div>
                                    <p class="name">{{product.name}}</p>
                                    <div class="product-detail-price" *ngIf="product.price">
                                        <p
                                            *ngIf="!product.discount && (product.calculation_type !=='sqft_wise' && product.calculation_type !=='sheet_wise' && product.calculation_type !=='meter_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.price |
                                            number:'1.0-1'}}
                                        </p>
                                        <p
                                            *ngIf="product.discount && (product.calculation_type !=='sqft_wise' && product.calculation_type !=='sheet_wise' && product.calculation_type !=='meter_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                            |
                                            number:'1.0-1'}}<br> <s style="color: #222;">MRP &#8377;{{product?.price
                                                |
                                                number:'1.0-1'}}</s> <span class="dis-off">{{product?.discount}}%
                                                Off</span>
                                        </p>


                                        <p
                                            *ngIf="!product.discount && (product.calculation_type ==='sqft_wise' || product.calculation_type ==='sheet_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.price |
                                            number:'1.0-1'}}/sqft
                                        </p>
                                        <p
                                            *ngIf="product.discount && (product.calculation_type ==='sqft_wise' || product.calculation_type ==='sheet_wise')">
                                            <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                            |
                                            number:'1.0-1'}}/sqft <br><s style="color: #222;">MRP
                                                &#8377;{{product?.price | number:'1.0-1'}}/sqft</s> <span
                                                class="dis-off">{{product?.discount}}% Off</span>
                                        </p>
                                        <p
                                        *ngIf="!product.discount && (product.calculation_type ==='meter_wise')">
                                        <span class="price-text">Price :</span> &#8377;{{product.price |
                                        number:'1.0-1'}}/Meter
                                    </p>
                                    <p
                                        *ngIf="product.discount && (product.calculation_type ==='meter_wise')">
                                        <span class="price-text">Price :</span> &#8377;{{product.effective_price
                                        |
                                        number:'1.0-1'}}/Meter <br><s style="color: #222;">MRP
                                            &#8377;{{product?.price | number:'1.0-1'}}/Meter</s> <span
                                            class="dis-off">{{product?.discount}}% Off</span>
                                    </p>
                                        <span class="size-font d-flex" *ngIf="product?.size">Size
                                            ({{product?.size}})</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                  
                </div>
            </div>
        </div>
        <div class="ab-container" *ngIf="!mostViewProductList?.length && global_loader && (maintabs===4)">
            <div class="row mt-24">
                <div class="col-12 popular-products-tab">
                    <ul class="product-card-2 is-loading loader-height">
                        <li *ngFor="let product of [1,2,3,4,5,6,7,8,9,10, 1,2,3,4,5,6,7,8,9,10]">
                            <div class="product-detail-container">
                                <div class="product-details-img product-img-1">
                                </div>
                                <div class="product-detail" style="margin-top: 6px;">
                                    <p class="brand"></p>
                                    <p class="name"></p>
                                    <div class="product-detail-price name"></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!---------------------------------Dealer section-------------------------------------------->
        <div class="ab-container ab-container-mb tab-pad" *ngIf="dealerSection" #dealer>
            <div class="city-page-container" *ngIf="show_location_popup && citytypes?.length">
                <div class="city-container d-flex" *ngFor="let city of citytypes;let i=index">
                    <a (click)="onCitySelect(city.name)" [title]="city.name">
                        <div class="city-img" [ngClass]="{'active-city-container':city_name===city.name}">
                            <img [src]="city.icon" [alt]="city.name">
                            <p>{{city.name}}</p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row ">
                <div class="col-12" *ngIf=" dealers_list?.length && !global_loader">
                    <div class="row dealer-details-page">
                        <div class="col-8">
                            <h3>Total Dealers: {{totalDealer}}</h3>
                        </div>

                        <ul class="dealer-details-container">
                            <li *ngFor="let dealer of dealers_list;let di=index;let last=last">
                                <a class="dealer-card" [title]="dealer?.showroom_name"
                                    (click)="onSelectDealer()" routerLink="../../dealer/{{dealer.slug_name}}">
                                    <span class="card-name">{{dealer?.showroom_name}}</span>
                                    <div class="dealer-shoowroom-img">
                                        <img [src]="dealer?.showroom_image_list[0]?.image"
                                            *ngIf="dealer?.showroom_image_list[0]?.image" [alt]="dealer?.showroom_name">
                                        <img class="img-not-found" *ngIf="!dealer.showroom_image_list[0]?.image"
                                            src="assets/images/noimageavail.png" [alt]="dealer?.showroom_name">
                                    </div>
                                    <div class="dealer-content">
                                        
                                        <p><span>{{dealer?.address2}},</span> {{dealer?.city}}</p>
                                        <div class="c-name"><i class="fa-solid fa-phone"></i> <a>+91
                                                {{dealer?.mobile}}</a></div>
                                        <div class="brand-auth">
                                            <span>Authorized seller for</span>
                                            <ul>
                                                <li [ngClass]="{'d-none':(bri+1) >= 6}"
                                                    *ngFor="let br of dealer?.brands;let bri=index">
                                                    <div class="br-card">
                                                        <img [src]="br?.logo" [alt]="br?.name">
                                                    </div>
                                                </li>
                                                <li class="d-flex" *ngIf="(dealer?.brands?.length >= 6)">
                                                    <span>{{dealer?.brands?.length - 6}} More</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12" *ngIf="global_loader">
                    <div class="row p-24 dealer-details-page is-loading">
                        <div class="col-8">
                            <h3></h3>
                        </div>
                        <div class="col-lg-6 col-md-12 col-12 p-2" *ngFor="let dealer of [1,2,3,4,5,6]">
                            <div class="dealer-card">
                                <div class="brand-images">
                                </div>
                                <div class="dealer-shop-img">
                                </div>
                                <div class="dealer-address">
                                    <h5 class="mb-1"></h5>
                                    <p></p>
                                    <a></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 p-24 text-center dealer-details-page"
                    *ngIf="!dealers_list?.length && !global_loader">
                    <div class="row NoProduct">
                        <div class="col-12 noproductscart pt-4">
                            <img class="ar"
                                src="https://res.cloudinary.com/afterbricks/image/upload/v1669102829/unnamed_m3qwbr.png"
                                alt="arrow">
                            <p class=" line-height-12">Dealer not available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ab-container mb-32" #company *ngIf="show_about_company && (maintabs===3)">
            <div class="company-details">
                <h3>About Company</h3>
                <div class="address-container">
                    <div class="aboy-us-sec">
                        <div [innerHTML]="brand_info?.about"></div>
                      </div>
                      <div class="w-100">
                        <p><span class="head-office">Head Office: </span></p>
                        <p class="head-office-address">
                            <span class="address"> {{ brand_info?.address}} {{brand_info?.city}}</span>
                            <span class="address" *ngIf="brand_info?.state">, {{brand_info?.state}}</span>
                            <span class="address" *ngIf="brand_info?.pincode">, pin code - {{brand_info?.pincode}}</span>
                        </p>
                      </div>
                   
                </div>
                <div class="wt-block w">
                    <p class="mb-32"><span class="head-office"> URL : </span> <a [title]="brand_info?.website"
                            class="address" target="_blank" href="{{brand_info?.website}}"
                            style="color: #2c72d2;">{{brand_info?.website}}</a></p>
                </div>
                <div class="m-block">
                    <p class="mb-32"><span class="head-office"> URL : </span> <br><a class="address" target="_blank"
                            href="{{brand_info?.website}}" style="color: #2c72d2;">{{brand_info?.website}}</a></p>
                </div>

            </div>
        </div>
        
        <app-footer *ngIf="!global_loader"></app-footer>
    </div>
</div>